var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2048 2048"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Type_01_Problem_Solving_Selected"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 2048
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Type_01_Problem_Solving_Selected",
    "data-name": "Icons_Type_01_Problem Solving_Selected",
    clipPath: "url(#clip-Icons_Type_01_Problem_Solving_Selected)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Type_01_Problem_Solving_Selected-2",
    "data-name": "Icons_Type_01_Problem Solving_Selected",
    transform: "translate(139.309 180.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(204.786 121.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 782.298,
    cy: 782.299,
    rx: 782.298,
    ry: 782.299,
    fill: "#eaeaea"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 82.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1381.9,651.371c-28.374-33.44-59.787-64.854-93.227-91.2-33.44-25.334-76-63.841-72.96-110.454,4.053-63.84,55.734-25.333,93.227-15.2,130.721,35.467,189.495-221.922,131.734-301.975-17.227-23.307-40.534-41.547-62.827-58.774-61.814-46.614-112.481-70.934-191.521-39.52-50.667,20.267-92.214,69.921-86.134,124.641,4.053,38.507,38.507,94.241-9.12,116.534-49.654,24.32-101.334-17.227-130.721-52.694-28.374-34.454-52.694-70.934-82.081-103.361-27.36-30.4-76-72.961-118.561-79.041-46.614-6.08-73.974,38.507-103.361,66.88L573.259,190.3,474.965,288.6a14.094,14.094,0,0,0,0,19.253l5.067,5.067c3.04,3.04,6.08,3.04,10.133,3.04,21.28,1.013,38.507,0,57.76,11.147C606.7,363.583,647.233,429.45,652.3,499.37c1.013,15.2,1.013,31.413-4.053,45.6-6.08,21.28-21.28,39.52-35.467,57.76-22.293,28.374-46.614,57.76-80.054,71.947-40.534,17.227-88.161,8.107-123.627-16.213s-60.8-62.827-77.014-102.347c-8.107-19.253-21.28-80.054-44.587-78.027-20.267,2.027-71.947,71.947-88.161,88.161L112.19,653.4c-27.36,27.36-58.774,46.614-88.161,71.947-4.053,3.04-8.107,7.093-10.133,12.16-2.027,6.08-1.013,12.16,1.013,18.24,8.107,25.333,30.4,40.534,47.627,58.774,24.32,25.333,49.654,49.654,74.987,74.987C171.977,923.96,206.43,971.587,245.95,999.96c16.213,12.16,38.507,19.254,57.76,14.187,25.333-7.093,40.534-30.4,54.72-52.694C378.7,932.067,402,902.68,432.4,884.44s70.934-24.32,102.347-7.093c14.187,8.107,25.333,19.253,36.48,31.413,34.453,37.494,66.88,81.067,70.934,131.734,3.04,42.56-16.213,85.121-45.6,117.548-25.333,27.36-57.76,47.627-91.2,63.84,21.28,42.56,66.88,65.867,103.36,96.267,24.32,19.253,44.587,42.56,68.907,61.813s52.694,34.454,84.107,34.454c47.627,0,87.147-34.454,120.587-66.881,27.36-26.347,59.787-48.64,83.094-77.014,22.293-25.334,38.507-46.614,74.987-37.494,27.36,7.093,48.64,35.467,48.64,63.841,0,12.16-3.04,23.307-2.027,34.453,3.04,30.4,32.427,49.654,59.787,63.84,21.28,11.147,42.56,21.28,66.88,24.32,51.68,7.093,103.36-21.28,133.761-63.841s40.534-95.254,40.534-146.934c0-28.374-4.053-59.787-27.36-76-18.24-14.187-43.574-13.174-66.88-14.187s-49.654-7.093-59.787-28.374c-30.4-57.761,80.054-138.828,112.481-172.268,46.614-47.627,112.481-120.587,84.107-193.548-7.093-17.227-18.24-33.44-29.387-48.64C1395.077,667.585,1389,659.478,1381.9,651.371Z",
    transform: "translate(-12.791 -20.104)",
    fill: "#633fda"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(14.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M39.5,645.616a12.852,12.852,0,0,1-6.08-1.013c-13.173-3.04-22.293-17.227-18.24-30.4A801.986,801.986,0,0,1,234.057,236.226C451.925,25.451,765.047-42.442,1051.822,56.865c13.173,5.067,20.267,19.253,15.2,32.427s-19.254,20.267-32.427,15.2c-268.535-94.241-561.39-29.387-765.071,167.2C169.2,368.974,98.27,490.575,63.816,625.349,61.789,637.509,50.643,645.616,39.5,645.616Z",
    transform: "translate(-14.204 -11.97)",
    fill: "#4c4c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(16.275 972.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M786.592,730.817c-212.8,0-421.549-85.12-574.564-243.2A794.349,794.349,0,0,1,15.44,140.04c-4.053-13.173,4.053-27.36,18.24-31.414,13.173-3.04,27.36,4.053,31.414,18.24,32.427,121.6,96.267,234.082,184.428,325.282,204.695,211.788,515.79,283.735,793.445,183.415,13.173-5.067,27.36,2.027,32.427,15.2s-2.027,27.36-15.2,32.427C971.02,714.6,878.806,730.817,786.592,730.817Z",
    transform: "translate(-14.397 -107.931)",
    fill: "#4c4c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(1423.669 451.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M178.782,826.048A22.291,22.291,0,0,1,165.608,822c-12.16-7.093-16.214-23.307-8.107-34.454C285.182,576.767,300.382,317.352,198.035,92.39c-6.08-13.173,0-27.36,12.16-33.44,13.173-6.08,27.36,0,33.44,12.16,108.427,239.148,93.227,516.8-43.574,741.765C196.008,822,187.9,826.048,178.782,826.048Z",
    transform: "translate(-153.284 -56.565)",
    fill: "#4c4c4c"
  })))))));
};
export default __webpack_public_path__ + "static/media/Icons_Type_01_Problem Solving_Selected.63f07be7.svg";
export { SvgComponent as ReactComponent };